// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "28bd0bc3e31eb5ca8850" + ".js";
};